import {NetworkEnums} from '../../../../shared/GameEnums'
import type {SocketController} from './SocketController'
import {ClientShuffleQueueController} from '../shuffle/ClientShuffleQueueController'
import {ShufflePlayerData, ShuffleQueueData} from '../../../../shared/shuffle_queue/ShuffleInterfaces'
import ShuffleState = NetworkEnums.ShuffleState
import ShuffleStateUpdateData = NetworkEnums.ShuffleStateUpdateData

export class SocketShuffleListen {
    // eslint-disable-next-line func-call-spacing
    private readonly shuffleStateHandlers = new Map<ShuffleState, (data: any) => void>()

    constructor(socketController: SocketController) {
        socketController.setStateHandler(NetworkEnums.State.ShuffleStateUpdate, (data: ShuffleStateUpdateData) => {
            this.shuffleStateHandlers.get(data.type)?.(data.payload)
        })

        this.shuffleStateHandlers.set(ShuffleState.ShuffleQueueData, (queueData: ShuffleQueueData) => {
            ClientShuffleQueueController.updateQueueData(queueData)
        })

        this.shuffleStateHandlers.set(ShuffleState.ShufflePlayerData, (playerData: ShufflePlayerData) => {
            ClientShuffleQueueController.updatePlayerData(playerData)
        })
    }
}

